
import TablePagination from '@mui/material/TablePagination';

interface IProps {
  rowsPerPageOptions: number[];
  onChangePage: (event: any, page: number) => void;
  onChangeRowsPerPage: (event: any) => void;
  rowCount: number;
  rowsPerPage: number;
  page: number;
}

const EDTablePagination: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <TablePagination
      sx={[
        {
          '.MuiTablePagination-spacer': { flex: 'unset' },
          '.MuiTablePagination-toolbar': {
            paddingLeft: theme => `${theme.spacing(0.25)}`,
          },
        },
      ]}
      rowsPerPageOptions={props.rowsPerPageOptions}
      onPageChange={props.onChangePage}
      onRowsPerPageChange={props.onChangeRowsPerPage}
      count={props.rowCount}
      rowsPerPage={props.rowsPerPage}
      component="div"
      page={props.page}
      backIconButtonProps={{
        color: 'primary',
      }}
      nextIconButtonProps={{
        color: 'primary',
        sx: {
          '.Mui-disabled': {
            color: theme => theme.palette.action.disabled,
          },
        },
      }}
    />
  );
};

export default EDTablePagination;
